const fallbackPickFirstString = (...values) => {
  for (const value of values) {
    const text = typeof value === 'string' ? value.trim() : '';
    if (text) return text;
  }
  return '';
};

export function buildGroupArtistProfilePayload({
  source,
  pickFirstString = fallbackPickFirstString,
  resolvePartLabel,
  defaultName = 'アーティスト',
}) {
  if (!source) return null;
  const name =
    pickFirstString(source.name, source.artist_name, source.name_en, source.artist_name_en) || defaultName;
  const partLabel = typeof resolvePartLabel === 'function'
    ? resolvePartLabel(source)
    : pickFirstString(source.partLabel, source.part, source.part_label, source.mainPartLabel, source.main_part_label);

  return {
    ...source,
    id: source.id || source.artist_id || source.artist_user_id || null,
    name,
    artist_name: name || source.artist_name || '',
    name_en: pickFirstString(source.name_en, source.artist_name_en),
    artist_name_en: pickFirstString(source.artist_name_en, source.name_en),
    pic: pickFirstString(source.pic, source.artist_profile_picture, source.profile_picture),
    artist_profile_picture: pickFirstString(
      source.artist_profile_picture,
      source.profile_picture,
      source.pic,
    ),
    partLabel,
    part: partLabel,
    custom_roles: Array.isArray(source.custom_roles)
      ? source.custom_roles
      : (Array.isArray(source.customRoles) ? source.customRoles : []),
    instagram_url: pickFirstString(source.instagram_url, source.instagram),
    twitter_url: pickFirstString(source.twitter_url, source.twitter),
    facebook_url: pickFirstString(source.facebook_url, source.facebook),
    hp_url: pickFirstString(source.hp_url, source.hp, source.homepage_url),
    career_timeline: Array.isArray(source.career_timeline)
      ? source.career_timeline
      : (Array.isArray(source.careerTimeline) ? source.careerTimeline : []),
    profile_one_liner: pickFirstString(
      source.profile_one_liner,
      source.one_liner,
      source.comment,
      source.bio,
      source.note,
      source.notes,
    ),
    eventMembershipLabel: pickFirstString(source.eventMembershipLabel, source.event_membership_label),
    eventPartLabel: pickFirstString(source.eventPartLabel, source.event_part_label),
    eventUuids: Array.isArray(source.eventUuids)
      ? source.eventUuids
      : (Array.isArray(source.event_uuids) ? source.event_uuids : []),
    eventPartAssignments: Array.isArray(source.eventPartAssignments)
      ? source.eventPartAssignments
      : (Array.isArray(source.event_part_assignments) ? source.event_part_assignments : []),
    groupEvents: Array.isArray(source.groupEvents)
      ? source.groupEvents
      : (Array.isArray(source.group_events) ? source.group_events : []),
    isUnifiedEventGroupChat:
      source.isUnifiedEventGroupChat === true || source.is_unified_event_group_chat === true,
  };
}

export function buildGroupAdminProfilePayload({
  source,
  pickFirstString = fallbackPickFirstString,
  defaultName = '管理者',
}) {
  if (!source) return null;
  const name =
    pickFirstString(source.full_name, source.admin_full_name, source.display_name, source.username, source.name) ||
    defaultName;

  return {
    ...source,
    id: source.id || source.admin_user_id || null,
    display_name: name,
    full_name: name,
    nickname: pickFirstString(source.nickname, source.display_name_sub),
    position: pickFirstString(source.position),
    department: pickFirstString(source.department),
    profile_picture: pickFirstString(source.profile_picture, source.admin_profile_picture, source.pic),
    profile_one_liner: pickFirstString(source.profile_one_liner, source.comment, source.note),
    eventMembershipLabel: pickFirstString(source.eventMembershipLabel, source.event_membership_label),
  };
}
